



































































import {
  Component, Vue,
} from 'vue-property-decorator';

import StepChooseGoalsWealthViewModel
  from '@/vue-app/view-models/components/flagship/flagship-link-goals/steps-wealth/step-choose-goals-wealth-view-model';

@Component({ name: 'StepChooseGoalsWealth' })
export default class StepChooseGoalsWealth extends Vue {
  step_choose_goals_wealth_model = Vue.observable(
    new StepChooseGoalsWealthViewModel(this),
  );

  created() {
    this.step_choose_goals_wealth_model.initialize();
  }
}
